import React, { forwardRef } from "react";
import { StyleSheet, type TextInput } from "react-native";

import { spacing } from "../../styles";
import Block from "../Block";
import Typography from "../Typography";
import Input from "./";
import type { InputProps } from "./types";

type Props = InputProps & { label: string; prefix: string };

const PhoneInput = forwardRef<TextInput, Props>(({ label, prefix, ...rest }: Props, ref) => {
  return (
    <Block style={styles.inputContainer}>
      <Input
        {...rest}
        inputStyle={styles.phoneInput}
        mask="PhoneNumber"
        placeholder={label}
        ref={ref}
        style={styles.phoneInputContainer}
        testID="phoneInput"
        textContentType="telephoneNumber"
      />
      <div style={styles.prefixInputContainer}>
        <Block alignCenter justifyCenter flex={1} paddingBottom={2.5}>
          <Typography type="secondary">{prefix}</Typography>
        </Block>
      </div>
    </Block>
  );
});

export default React.memo(PhoneInput);

const styles = StyleSheet.create({
  inputContainer: {
    flex: 1,
  },
  phoneInput: {
    paddingLeft: spacing.unit * 6.5,
  },
  phoneInputContainer: {
    flex: 1,
  },
  prefixInputContainer: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    pointerEvents: "none" as const,
    position: "absolute",
    width: spacing.unit * 7,
    zIndex: 1,
  },
});
